/**
 * Ckeck if item has every prop passed in param
 * Use with .filter() ex: arrayOfObject.filter(has(prop.deep.value))
 *
 * @param  {...any} deepPaths 
 * @returns {Boolean}
 */
export const hasEveryProp = (...deepPaths) => (item) => deepPaths
    .every(deepPath => deepFind(item, deepPath))
;

/**
 * Couple for each item of array two properties of object to create an object of few key:value
 * Use with .reduce() ex: arrayOfObject.reduce(couple(prop.deep.prop, prop))
 *
 * @param {*} key 
 * @param {*} deepPath 
 * @returns an object of few key:value
 */
export const couple = (key, deepPath) => (obj, curr) => ({...obj, [curr[key]]:deepFind(curr, deepPath)});

/**
 * Search deep in an object a value according deep path
 *
 * @param {*} objet 
 * @param {*} deepPath 
 * @returns return value of search or undefined if path is incorrect
 */
export const deepFind = (objet, deepPath) => deepPath
    .split('.')
    .reduce((obj, path) => obj === undefined ? obj : obj[path], objet)
;

/**
 * Sort an object by the key
 * @param {String} by key of object needed to sorted
 * @param {Object} aggregations object to sorted
 * @returns object
 */
 export const sortDescBy = by => object => Object.entries(object)
    .sort(([,a],[,b]) => b[by] - a[by])
    .reduce((obj, [k, v]) => ({...obj, [isNaN(k) ? k : `key_${k}`]: v}), {})
;

/**
 * Composition utility function
 * @param  {...any} fns all the functions called in the chain
 * @returns 
 */
export const pipe = (...fns) => x => fns.reduce((y, f) => f(y), x);

/**
 * Generate guid
 * @returns random guid
 * DEPRECATED : use instead https://www.npmjs.com/package/uuid
 */
export const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}